export const en = {
    "providerTeam":{
        "list":"Service provider team",
        "total":"Total",
        "records":"Records",
        "refresh":"Refresh data",
        "search":"Search",
        "vipId":"Vip ID",
        "distributor":"Distributor",
        "serviceProvider":"Service provider",
        "superior":"Superior",
        "status":"State",
        "Account":"Account overview",
        "current":"Current commission",
        "accumulated":"Accumulated Commission",
        "settlement":"Commission in settlement",
        "settled":"Settled Commission",
        "money":"element",
        "team":"Team overview",
        "member":"Total number of offline members",
        "primary ":"Primary service provider",
        "secondary":"Secondary service provider",
        "nickname":"Nickname of service provider",
        "online":"Direct online",
        "level":"Service provider level",
        "available":"Available funds",
        "freezing":"Freezing of funds",
        "share":"Share proportion",
        "operation":"operation",
        "providers":"New service providers"
    },
    "customers":{
        "list":"Distribution customers",
        "enterprise":"Enterprise name",
        "person":"Name of person in charge",
        "search":"Search",
        "nickname":"Member nickname",
        "consumption":"Total consumption",
        "purchased":"Name of purchased goods",
        "date":"Date of purchase",
        "operation":"operation"
    },
    "commodity":{
        "list":"Distribution goods",
        "name":"Commodity name",
        "volume":"Sales volume",
        "classification":"classification",
        "price":"Price",
        "stock":"Stock",
        "commission":"Commission sharing ratio",
        "operation":"operation"
    },
    "order":{
        "list":"Distribute order",
        "number":"order number",
        "time":"Order time",
        "person":"Next person",
        "contact":"contact number",
        "consignee":"Consignee",
        "iphone":"contact number",
        "payment":"Payment time",
        "operation":"operation",
        "details":"Order details",
        "information":"Product information",
        "orderID":"order ID",
        "goodsName":"Commodity name",
        "goodsNum":"Quantity of goods",
        "amount":"Commodity amount",
        "service":"Service provider information",
        "serviceName":"Name of service provider",
    },
    "commission":{
        "list":"Distribution Commission",
        "number":"order number",
        "time":"Order time",
        "name":"Commodity name",
        "price":"Unit Price",
        "quantity":"Quantity",
        "commission":"Commission sharing ratio",
        "amount":"Commission amount",
        "operation":"operation",
        "undrawnCommission":"Undrawn Commission",
        "WithdrawnCommission":"Withdrawn Commission",
        "applicant":"Applicant ID",
        "applicantName":"Name of applicant",
        "applicationTime":"Application time",
        "applicationAmount":"Application amount",
        "orderNo":"Order No",
        "state":"state"
    },
    "providerTeamDeatil":{
        "providers":"New service providers",
        "account":"account number",
        "pleaseAccount":"Please enter the account number",
        "password":"password",
        "pleasePassword":"Please input a password",
        "phone":"cell-phone number",
        "PleaseMobile":"Please enter your mobile number",
        "name":"Enterprise name",
        "pleaseName":"Please enter the enterprise name",
        "person":"legal person",
        "pleasePerson":"Please enter the legal person's name",
        "address":"Business address",
        "pleaseAddress":"Please enter the business address",
        "receiving":"Account number of receiving bank",
        "pleaseReceiving":"Please enter the bank collection account number",
        "area":"Province / city / district",
        "pleaseArea":"Please select a province / city / district",
        "now":"Create now",
        "cancel":"cancel",
        "contactPerson":"contact person",
        "pleaseContact":"Please enter the contact person"
    },
    "UploadInvoice":{
        "essential":"essential information",
        "OrderID":"Order ID",
        "orderNo":"Withdrawal order No",
        "member":"member",
        "phone":"Telephone",
        "time":"Application time",
        "withdrawal":"Withdrawal information",
        "WithdrawalAmount":"Withdrawal amount",
        "bankAccount":"Withdrawal bank account",
        "type":"Withdrawal type",
        "orderInformation":"Withdrawal order information",
        "orderNumber":"order number",
        "orderTime":"Order time",
        "commodityName":"Commodity name",
        "price":"Unit Price",
        "quantity":"quantity",
        "ratio":"Share ownership ratio",
        "sharingAmount":"Sharing amount",
        "attachment":"Upload invoice attachment"
    }
}

export const zh = {
    "providerTeam":{
        "list":"服务商团队",
        "total":"共",
        "records":"条记录",
        "refresh":"刷新数据",
        "search":"搜索",
        "vipId":"会员ID",
        "distributor":"分销商",
        "serviceProvider":"服务商",
        "superior":"上级",
        "status":"状态",
        "Account":"账户概况",
        "current":"当前佣金",
        "accumulated":"累计佣金",
        "settlement":"结算中佣金",
        "settled":"已结算佣金",
        "money":"元",
        "team":"团队概况",
        "member":"下线会员总数",
        "primary":"一级服务商",
        "secondary":"二级服务商",
        "nickname":"服务商昵称",
        "online":"直属上线",
        "level":"服务商层级",
        "available":"可用资金",
        "freezing":"冻结资金",
        "share":"分成比例",
        "operation":"操作",
        "providers":"新增服务商"
    },
    "customers":{
        "list":"客户管理",
        "enterprise":"企业名称",
        "person":"负责人名称",
        "search":"搜索",
        "nickname":"采购人名称",
        "consumption":"总消费",
        "purchased":"购买商品名称",
        "date":"购买日期",
        "operation":"操作"
    },
    "commodity":{
        "list":"渠道商品",
        "name":"商品名称",
        "volume":"销量",
        "classification":"分类",
        "price":"价格",
        "stock":"库存",
        "commission":"分佣比例",
        "operation":"操作"
    },
    "order":{
        "title":"订单管理",
        "list":"渠道订单",
        "number":"订单号",
        "time":"订单时间",
        "person":"采购人名称",
        "contact":"联系电话",
        "consignee":"收货人",
        "iphone":"联系电话",
        "payment":"支付时间",
        "operation":"操作",
        "details":"订单详情",
        "information":"商品信息",
        "orderID":"商品ID",
        "goodsName":"商品名称",
        "goodsNum":"商品数量",
        "amount":"商品金额",
        "service":"服务商信息",
        "serviceName":"服务商名称"
    },
    "commission":{
        "list":"渠道服务费",
        "number":"订单号",
        "time":"下单时间",
        "name":"商品名称",
        "price":"单价",
        "quantity":"数量",
        "commission":"分佣比例",
        "amount":"分佣金额",
        "operation":"操作",
        "undrawnCommission":"未提现佣金",
        "WithdrawnCommission":"已提现佣金",
        "applicant":"申请人ID",
        "applicantName":"申请人名称",
        "applicationTime":"申请时间",
        "applicationAmount":"申请金额",
        "orderNo":"所属订单号",
        "state":"状态"

    },
    "providerTeamDeatil":{
        "providers":"新增服务商",
        "account":"账号",
        "pleaseAccount":"请输入账号",
        "password":"密码",
        "pleasePassword":"请输入密码",
        "phone":"手机号",
        "PleaseMobile":"请输入手机号",
        "name":"企业名称",
        "pleaseName":"请输入企业名称",
        "person":"法人",
        "pleasePerson":"请输入法人姓名",
        "address":"企业地址",
        "pleaseAddress":"请输入企业地址",
        "receiving":"收款银行账号",
        "pleaseReceiving":"请输入银行收款账号",
        "area":"省/市/区",
        "pleaseArea":"请选择省/市/区",
        "now":"立即创建",
        "cancel":"取消",
        "contactPerson":"联系人",
        "pleaseContact":"请输入联系人"
    },
    "UploadInvoice":{
        "essential":"基本信息",
        "OrderID":"订单ID",
        "orderNo":"提现订单号",
        "member":"会员",
        "phone":"电话",
        "time":"申请时间",
        "withdrawal":"提现信息",
        "WithdrawalAmount":"提现金额",
        "bankAccount":"提现银行账号",
        "type":"提现类型",
        "orderInformation":"提现订单信息",
        "orderNumber":"订单号",
        "orderTime":"下单时间",
        "commodityName":"商品名称",
        "price":"单价",
        "quantity":"数量",
        "ratio":"分拥比例",
        "sharingAmount":"分拥金额",
        "attachment":"上传发票附件"
    }
}
